document.addEventListener('DOMContentLoaded', () => {
  const navigations = document.querySelectorAll('.n-main-navigation')
  navigations.forEach((navigation) => {
    const burger = navigation.querySelector('.burger-menu')
    const offCanvasMenu = navigation.querySelector('.off-canvas-menu')
    const logo = navigation.querySelector('.logo')
    const subLogo = navigation.querySelector('.sub-logo')
    let scrollTop = window.pageYOffset || (document.documentElement || document.body.parentNode || document.body).scrollTop

    let menuOpen = false

    burger.addEventListener('click', (e) => {
      toggleMenu()

      if (menuOpen) {
        subLogo.classList.add('visible')
      }
    })

    // TODO: SCHLIESSE MENÜ, WENN HOST und HREF gleich
    if (offCanvasMenu) {
      const links = offCanvasMenu.querySelectorAll('a[href*="#"]')
      if (links) {
        links.forEach((link) => {
          link.addEventListener('click', (e) => {
            toggleMenu()
          })
        })
      }
    }

    function scrollMonitor () {
      scrollTop = window.pageYOffset || (document.documentElement || document.body.parentNode || document.body).scrollTop
      if (logo && subLogo) {
        if (scrollTop > 0 && !menuOpen) {
          logo.classList.add('small')
          subLogo.classList.remove('visible')
        } else {
          subLogo.classList.add('visible')
          logo.classList.remove('small')
        }
      }
    }
    window.addEventListener('scroll', () => {
      scrollMonitor()
    })

    scrollMonitor()

    function toggleMenu () {
      if (menuOpen) {
        burger.classList.remove('burger-menu--opened')
        offCanvasMenu.classList.remove('off-canvas-menu--opened')
        setTimeout(() => {
          offCanvasMenu.style.display = 'none'
          menuOpen = !menuOpen
        }, 400)
      } else {
        offCanvasMenu.style.display = 'block'
        logo.classList.remove('small')
        subLogo.classList.add('visible')
        setTimeout(() => {
          offCanvasMenu.classList.add('off-canvas-menu--opened')
          burger.classList.add('burger-menu--opened')
          menuOpen = !menuOpen
        }, 0)
      }
    }
  })
})
